module.exports = __webpack_public_path__ + "img/MapThumb_NoMansLand.aaca2b37.webp";